<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-indent:0em;">This book would not have been possible if it wasn’t for a few special people in my life. To my beloved mother, you have shown admirable strength and patience. You put your entire life on hold to save mine.</p><br/>
<p style="text-indent:0em;">To my father, thank you for being the backbone of this family.</p><br/>
<p style="text-indent:0em;">To my family, my support system, my anchor in the storm I will forever be grateful to have you all.</p><br/>
<p style="text-indent:0em;">To Dr. Owega, you gave me a second chance in life, with your guidance and care I have come a long way.</p><br/>
<p style="text-indent:0em;">To Sophie, a therapist who has provided a safe space for me to hear and see my thoughts.</p><br/>
<p style="text-indent:0em;">To Abhishek Tiwari, a true friend who supported me through a crucial part of my journey with his unmatched generosity.</p><br/>
<p style="text-indent:0em;">To Mr. Kapec, thank you for being one of the first people to read my book and giving impeccable feedback.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?3a4ef584